/* Mantún (13-10-2026, copia del arreglo de FunFungi). Regalos de Kaching en el carrito.
 * Las líneas de regalo (precio final $0 con precio de lista; no basta la propiedad "gift" de Kaching)
 * traían «+ / −»: en FunFungi, tocar «+» sumaba el regalo a precio completo sin aviso.
 * Desde 2 kits Kaching regala Cosecha Garantizada, la Guía y el Pack de Jeringas Misterioso (los 2 primeros también con 1 kit).
 * Regalos cobrados (13-10, probado en el publicado): al bajar de 2 kits a 1 con «−», Kaching deja el Pack de Jeringas
 * con su marca de regalo pero cobrándolo a $14.990 (defecto reconocido por Kaching en FunFungi). Este script quita solas
 * del carrito las líneas con marca de regalo de Kaching que se estén cobrando. Solo quita, nunca agrega: si el cliente
 * vuelve a subir a 2 kits, el regalo no vuelve solo (igual que al borrarlo a mano). Un producto comprado aparte (sin la
 * marca de Kaching) nunca se toca. Usa el mismo updateQuantity del tema, que redibuja el carrito.
 * Aquí se marca la fila con .mt-regalo, se esconde el selector de cantidad y la etiqueta de
 * descuento de Kaching («2 packs») y se muestra «Regalo». El botón de eliminar se mantiene.
 * En los regalos digitales (guías) también se esconden el precio tachado y «(Ahorra …)».
 * Carrito lateral: #CartDrawer-Item-N · página /cart: #CartItem-N (N = posición en /cart.js). */
(function () {
  'use strict';
  if (window.mtRegalosCarrito) return;
  window.mtRegalosCarrito = true;

  var css = document.createElement('style');
  css.textContent =
    '.mt-regalo quantity-input,.mt-regalo .cart-drawer__discounts,.mt-regalo .cart-item__discounts{display:none!important}' +
    '.mt-regalo-digital .cart-item__old-price,.mt-regalo-digital .cart-drawer-item__saving{display:none!important}' +
    '.mt-regalo-etiqueta{display:inline-flex;align-items:center;gap:.4em;padding:.35em .8em;border-radius:999px;' +
    'background:#fbeef3;color:#8a2f58;font-size:1.25rem;font-weight:600;line-height:1.2;white-space:nowrap}';
  document.head.appendChild(css);

  // Solo es regalo si hoy cuesta $0. Ojo: si el cliente baja de 2 a 1 pack, Kaching deja el café con la marca
  // "gift" pero cobrándolo a precio completo; esa línea NO se marca, para que vea el precio y pueda quitarlo.
  // Regalos digitales (las guías): sin precio tachado ni «(Ahorra …)», porque no son un ahorro real (pedido de Mau,
  // 12-10). Son los productos con la etiqueta «regalo-digital»; /cart.js no trae etiquetas, así que van por handle.
  var DIGITALES = []; // Mantún: sin regalos digitales por ahora

  function esRegalo(item) {
    return item.final_line_price === 0 && item.original_line_price > 0;
  }

  function regaloCobrado(item) {
    var k = item.properties && item.properties.__kaching_bundles;
    if (!k || item.final_line_price <= 0) return false;
    try { return !!JSON.parse(k).gift; } catch (e) { return /"gift"/.test(k); }
  }

  // Cada línea se intenta quitar una vez por página: si Shopify rechaza el cambio, no se insiste en bucle.
  var intentados = {};
  function quitarCobrado(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!regaloCobrado(item) || intentados[item.key]) continue;
      intentados[item.key] = true;
      var enPagina = document.querySelector('#main-cart-items cart-items, cart-items#main-cart-items, cart-items');
      var lista = (location.pathname.indexOf('/cart') === 0 && enPagina) || document.querySelector('cart-drawer-items') || enPagina;
      if (lista && typeof lista.updateQuantity === 'function') {
        lista.updateQuantity(i + 1, 0);
      } else {
        fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 0 }) })
          .then(function () { location.reload(); });
      }
      return true; // una a la vez: al redibujarse el carrito, se vuelve a revisar
    }
    return false;
  }

  var pendiente = null;
  var enCurso = false;

  function marcar() {
    if (enCurso) { pendiente = pendiente || setTimeout(function () { pendiente = null; marcar(); }, 300); return; }
    enCurso = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (quitarCobrado(cart)) return;
        cart.items.forEach(function (item, i) {
          var n = i + 1;
          var regalo = esRegalo(item);
          document.querySelectorAll('#CartDrawer-Item-' + n + ', #CartItem-' + n).forEach(function (fila) {
            fila.classList.toggle('mt-regalo', regalo);
            fila.classList.toggle('mt-regalo-digital', regalo && DIGITALES.indexOf(item.handle) !== -1);
            var etiqueta = fila.querySelector('.mt-regalo-etiqueta');
            if (regalo && !etiqueta) {
              var lugar = fila.querySelector('.cart-item__quantity-wrapper') || fila.querySelector('.cart-item__quantity');
              if (lugar) {
                etiqueta = document.createElement('span');
                etiqueta.className = 'mt-regalo-etiqueta';
                etiqueta.textContent = '🎁 Regalo';
                lugar.insertBefore(etiqueta, lugar.firstChild);
              }
            } else if (!regalo && etiqueta) {
              etiqueta.remove();
            }
          });
        });
      })
      .catch(function () { /* sin red: se queda como está */ })
      .then(function () { enCurso = false; });
  }

  // El carrito se redibuja entero al agregar, quitar o cambiar cantidades: observar y volver a marcar.
  var espera = null;
  function programar() { clearTimeout(espera); espera = setTimeout(marcar, 150); }
  function observar() {
    var obs = new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var t = cambios[i].target;
        if (t.closest && t.closest('.mt-regalo-etiqueta')) continue;
        programar();
        return;
      }
    });
    document.querySelectorAll('cart-drawer, cart-items, #main-cart-items, .cart-items').forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true });
    });
    programar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observar);
  else observar();
})();
